import React from 'react';
import PropTypes from 'prop-types';
import { PERFORMANCE_LEVEL_MAP } from '../../legendConstants';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const PerformanceLevelSection = ({ performanceLevelList }) => (
    <div className="section colors">
        <h3 className="section-name levels">
            Benchmark/
            <br /> Proficiency Level
        </h3>
        {performanceLevelList.map(({ color, levelTitle }) => (
            <div
                className={`wrap ${color}`}
                key={generateReactKey(levelTitle)}
                data-test-id="performance-levels"
            >
                <div className="square" />
                <div>{levelTitle}</div>
            </div>
        ))}
    </div>
);

PerformanceLevelSection.defaultProps = {
    performanceLevelList: PERFORMANCE_LEVEL_MAP,
};

PerformanceLevelSection.propTypes = {
    performanceLevelList: PropTypes.array,
};

export default PerformanceLevelSection;
